import { EnvType } from '@root/globalTypes';

export const getEnvType = (): EnvType => {
  const apiUrl = import.meta.env.VITE_API_URL as string;
  if (apiUrl.includes('stage')) return 'stage';
  if (apiUrl.includes('uat')) return 'uat';
  return 'prod';
};
